<template>
  <base-card @close="close">
    <div id="package-creation-wrapper">
      <heading :heading="components[activeComponentIndex].component" />
      <Component
        :is="components[activeComponentIndex].component"
        :subject="subject"
        @name-input="nameInput"
        @photo-input="photoInput"
        @description-input="descriptionInput"
        @pricing-input="pricingInput"
        @add-service="addService"
        @remove-service="removeService"
        @add-form="addForm"
        @remove-form="removeForm"
        @add-contract="addContract"
        @remove-contract="removeContract"
      />
      <div class="button-container">
        <Button
          :text="components[activeComponentIndex].buttons[0]"
          @click="back"
        /><Button
          :text="components[activeComponentIndex].buttons[1]"
          @click="next"
        />
      </div></div
  ></base-card>
</template>
<script>
import Button from "@/Components/UI/Button.vue";
import Heading from "@/Components/UI/Heading.vue";
import BaseCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import Details from "./Details.vue";
import Services from "./Services.vue";
import Forms from "./Forms.vue";
import Contracts from "./Contracts.vue";
import Pricing from "./Pricing.vue";
export default {
  data() {
    return {
      activeComponentIndex: 0,
      components: [
        {
          component: "Details",
          buttons: ["Close", "Next"],
        },
        {
          component: "Services",
          buttons: ["Back", "Next"],
        },
        {
          component: "Forms",
          buttons: ["Back", "Next"],
        },
        {
          component: "Contracts",
          buttons: ["Back", "Next"],
        },
        {
          component: "Pricing",
          buttons: ["Back", "Finish"],
        },
      ],
      subject: {
        id: "package" + new Date().getTime(),
        name: undefined,
        priceOption: undefined,
        pricing: {
          baseTime: undefined,
          baseRate: undefined,
          addHourly: undefined,
        },
        forms: [],
        contracts: [],
        serviceIds: [],
        services: [],
        employeesRequired: undefined,
        photo: undefined,
        description: undefined,
      },
    };
  },
  computed: {},
  methods: {
    back() {
      if (this.activeComponentIndex > 0) {
        this.activeComponentIndex--;
      } else {
        this.close();
      }
    },
    next() {
      if (this.activeComponentIndex < 4) {
        this.activeComponentIndex++;
      } else {
        this.addPackage();
      }
    },
    close() {
      this.$emit("close");
    },
    async addPackage() {
      this.$emit("add-package", this.subject);
    },
    nameInput(value) {
      this.subject.name = value;
    },
    descriptionInput(value) {
      this.subject.description = value;
    },
    photoInput(photo) {
      this.subject.photo = photo;
    },
    pricingInput(pricing) {
      this.subject = { ...this.subject, ...pricing };
    },
    addService(service) {
      this.subject.services.push(service);
    },
    removeService(service) {
      let index = this.subject.services.indexOf(service);
      this.subject.services.splice(index, 1);
    },
    addForm(form) {
      this.subject.forms.push(form);
    },
    removeForm(form) {
      let index = this.subject.forms.indexOf(form);
      this.subject.forms.splice(index, 1);
    },
    addContract(contract) {
      this.subject.contracts.push(contract);
    },
    removeContract(contract) {
      let index = this.subject.contracts.indexOf(contract);
      this.subject.contracts.splice(index, 1);
    },
  },
  // todo : change serviceIds to services for cleaner code
  components: {
    BaseCard,
    Button,
    Heading,
    Details,
    Services,
    Forms,
    Contracts,
    Pricing,
  },
  created() {
    if (this.package) {
      this.subject = this.package;
      this.subject.pricing.baseRate = this.subject.pricing.baseRate / 100;
      this.subject.pricing.addHourly = this.subject.pricing.addHourly / 100;
    }
  },
  props: ["package", "mode"],
  emits: ["close", "add-package"],
};
</script>
<style scoped>
@media screen {
  .button-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  .scs-button {
    margin: 5px;
  }
  @media (min-width: 800px) {
    #package-creation-wrapper {
      width: 65vw;
    }
  }
}
</style>
